import * as React from 'react';

/** Material UI Packages. */
import Grid from '@mui/material/Grid2';
import { Box, Typography } from '@mui/material';

/** Internal Components. */
import CategoryAccordion from 'shared/ui/CategoryAccordion';

/**
 * MemberColumn component to display the member's information and todo sections.
 * @param {Object} member - The member's information.
 * @param {Array} categories - The categories of the todo sections.
 * @param {Array} todoSections - The todo sections.
 * @returns {JSX.Element} The MemberColumn component.
 */
export default function MemberColumn({ member, categories, todoSections }) {
    /** Calculate the total row sum of the todo sections. */
    const totalRowSum = categories.reduce((sum, option) => {
        const isMatched = todoSections.filter((item) => item.value === option.value);
        const totalRowCount = isMatched.reduce((s, section) => s + (section.data?.length || 0), 0);
        return sum + totalRowCount;
    }, 0);

    return (
        <Grid item={12} size={2.4} sx={{ maxHeight: '83vh', overflow: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', px: 0.2, mb: 1 }}>
                <Typography sx={{ fontSize: 15, fontWeight: 500, color: '#003a52', px: 1 }}>{member}</Typography>
                <Typography
                    sx={{
                        fontSize: 12,
                        fontWeight: 500,
                        backgroundColor: '#e0e0e0',
                        borderRadius: '9.5px',
                        width: 30,
                        height: 18,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 0 2px rgba(0,0,0,0.2)',
                    }}
                >
                    {totalRowSum}
                </Typography>
            </Box>
            {categories.map((option) => {
                const isMatched = todoSections.filter((item) => item.value === option.value);
                return <CategoryAccordion key={option.id} option={option} sections={isMatched} />;
            })}
        </Grid>
    );
}
